import { Cell, flexRender } from '@tanstack/react-table';
import { RefObject, useEffect, useRef } from 'react';
import { Components } from 'react-virtuoso';
import { useColumnResizingContext } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { useMatchMedia } from 'src/hooks/useMatchMedia';
import { PosTableData } from 'src/tables/Table';
import { PosGroupedVirtuosoContext } from 'src/tables/Table/GroupedVirtuosoTable/PosGroupedVirtuosoContext';

import { TableTd } from '../components/TableTd';
import * as styles from '../Table.css';

export const PosGroupedVirtuosoFooter: Components['Footer'] = ({
  context,
  ...props
}) => {
  const { table, useDataGrouping, showFooter } =
    context as PosGroupedVirtuosoContext<PosTableData>;
  const { isResizeEnabled } = useColumnResizingContext();
  const ref = useRef<HTMLDivElement>(null);

  const footerRow = table.getFooterGroups();
  const isLargeDesktop = useMatchMedia('largeDesktop');

  useEffect(() => {
    if (!showFooter || !useDataGrouping) return;
    const el = ref as RefObject<HTMLDivElement> | null;
    const parent = el?.current?.parentElement;

    // Hack to make the footer sticky - it's useful only when applying to the parent div if using grouped virtuoso
    if (parent) {
      parent.classList.add(styles.PosTableFooterSticky);
    }

    return () => {
      if (parent) parent.classList.remove(styles.PosTableFooterSticky);
    };
  }, [ref, showFooter, useDataGrouping]);

  if (!showFooter) return null;

  return (
    <div ref={ref} {...props}>
      <table className={styles.table}>
        <tfoot>
          {footerRow.map((row, index) => (
            <tr
              className={styles.tableFooterRow}
              key={`footer-${index}-${row.id}`}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {row.headers.map((cell) => (
                <TableTd
                  key={cell.id}
                  isLargeDesktop={isLargeDesktop}
                  isResizeEnabled={isResizeEnabled}
                  cell={cell as unknown as Cell<unknown, unknown>}
                >
                  {flexRender(cell.column.columnDef.footer, cell.getContext())}
                </TableTd>
              ))}
            </tr>
          ))}
        </tfoot>
      </table>
    </div>
  );
};
